import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("kcal: "),
  /*#__PURE__*/_createElementVNode("em", null, "der"),
  /*#__PURE__*/_createTextVNode(" Kalorien-Calculator")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalcWeight = _resolveComponent("CalcWeight")!
  const _component_IngredientList = _resolveComponent("IngredientList")!
  const _component_serving_result = _resolveComponent("serving-result")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_CalcWeight, {
      onWeightCorrection: _cache[0] || (_cache[0] = val => _ctx.weightCorrection = val),
      onCalculatedWeight: _cache[1] || (_cache[1] = val => _ctx.calculatedWeight = val),
      ingredients: _ctx.ingredients
    }, null, 8, ["ingredients"]),
    _createVNode(_component_IngredientList, {
      onNewIngredient: _ctx.addIngredient,
      onRemoveIngredient: _ctx.removeIngredient,
      ingredients: _ctx.ingredients
    }, null, 8, ["onNewIngredient", "onRemoveIngredient", "ingredients"]),
    _createVNode(_component_serving_result, {
      "data-ingredients": JSON.stringify(_ctx.servingIngredients)
    }, null, 8, ["data-ingredients"])
  ], 64))
}